import {
 SEND_OTP_REQUEST,
  SEND_OTP_SUCCESS,
  SEND_OTP_FAILURE,
  VERIFY_OTP_REQUEST,
  VERIFY_OTP_SUCCESS,
  VERIFY_OTP_FAILURE,
} from '../actions/types';

const initialState = {
  loading: false,
  otpStatus: null,
  verifyStatus: null,
  error: null,
};

export default function(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SEND_OTP_REQUEST:
    case VERIFY_OTP_REQUEST:
      return { 
        ...state, 
        loading: true, 
        error: null 
      };

    case SEND_OTP_FAILURE:
    case VERIFY_OTP_FAILURE:
      return { 
        ...state, 
        loading: false, 
        error: payload 
      };

    case SEND_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        otpStatus: payload,
        error: null,
      };

    case VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: false,
        verifyStatus: payload,
        error: null,
      };
   
    default:
      return state;
  }
}